import { Page } from '@app/components/page/Page';
import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { Box, Divider } from '@mui/material';
import { useIntl } from 'react-intl';
import { LoggerModule } from '../../..';
import { StatusViewToggle } from '../StatusViewToggle';
import { FullscreenViewToggle } from './FullscreenViewToggle';
import { StatusActivityFilter } from './StatusActivityFilter';
import { StatusStationAccessFilter } from './StatusStationAccessFilter';
import { StatusStationTypeFilter } from './StatusStationTypeFilter';
import { StatusesTextFilter } from './StatusesTextFilter';
import { StationStatus } from '../../types';

export function StatusesHeader({
  statuses,
  isLoading = false,
}: {
  statuses: StationStatus[];
  isLoading?: boolean;
}) {
  const { $t } = useIntl();

  const title = $t({
    id: 'logger.statusScreen.title',
    defaultMessage: 'Panorama',
  });

  return (
    <Page.Header
      icon={<LoggerIcon />}
      title={[LoggerModule.title, title]}
      actions={
        <Box display="flex" alignItems="center" gap={2}>
          <Box sx={{ width: 140 }}>
            <StatusesTextFilter />
          </Box>
          <StatusStationTypeFilter />
          <StatusStationAccessFilter />
          <StatusActivityFilter statuses={statuses} isLoading={isLoading} />
          <Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 1 }} />
          <Box display="flex" alignItems="center" gap={1}>
            <StatusViewToggle />
            <FullscreenViewToggle />
          </Box>
        </Box>
      }
    />
  );
}
